import GroupSearch from './groupSearch';

export default GroupSearch;
